<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <core-card [actions]="[]">
      <div class="card-body w-100 pb-0">
        <div class="row">
          <div class="col-lg-2 col-12 mb-1 mb-lg-0">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="filterList()" />
          </div>
          <div class="col-lg-3 col-12 mb-1 mb-lg-0">
            <ng-select
              class="w-100"
              id="figure"
              [(ngModel)]="filterFigure"
              [closeOnSelect]="true"
              placeholder="{{ 'FIGURE' | translate }}"
              [openOnEnter]="true"
              [virtualScroll]="true"
              [clearable]="true"
              (ngModelChange)="filterList()"
            >
              <ng-option *ngFor="let figure of figuresList" [value]="figure.id">{{ figure.name }}</ng-option>
            </ng-select>
          </div>
          <div class="col-lg-7 col-12">
            <div class="row justify-content-lg-end justify-content-center">
              <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" [ngClass.md]="'d-none'">
                <label class="d-flex align-items-center mb-0"
                >{{ "SHOW" | translate }}
                  <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body px-0 pb-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="50"
          [scrollbarH]="true"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="_utilService.isDesktop ? 80 : 200"
          [limit]="10"
          [footerHeight]="30"
          [rows]="filteredCandidateList"
        >
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" width="700" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile align-items-center">
                <div class="col-12 pl-0">
                  <span class="font-weight-bold">{{ "FIRSTNAME" | translate }}: </span>
                  <span>{{ row.firstname + " " + row.lastname | titlecase }}</span>
                </div>
                <div class="col-12 pl-0">
                  <span class="font-weight-bold">{{ "FIGURE" | translate }}: </span>
                  <span>{{ row.figure_name ? row.figure_name : "-" }}</span>
                </div>
                <div class="col-12 pl-0">
                  <span class="font-weight-bold">{{ "CITY" | translate }}: </span>
                  <span>{{ row.city_name ? row.city_name : "-" }}</span>
                </div>
                <div class="col-12 pl-0">
                  <span class="font-weight-bold">{{ "INSERT_DATE" | translate }}: </span>
                  <span>{{ _utilService.formatDate(row.created_date, "DD/MM/YYYY HH:mm") }}</span>
                </div>
                <div class="col-12 pl-0">
                  <a *ngIf="row.email" [href]="'mailto:' + row.email" class="text-danger" [ngbTooltip]="'SEND_EMAIL' | translate">
                    <i [data-feather]="'mail'" size="20" class="mr-05"></i>
                    <span>{{ row.email ? row.email : "-" }}</span>
                  </a>
                </div>
                <div class="col-12 mt-075">
                  <div class="d-flex justify-content-end">
                    <button class="bg-transparent border-0 pr-1" (click)="modalOpen(detailCandidate, row)">
                      <i [data-feather]="'eye'" size="19"></i>
                    </button>
                    <button
                      class="bg-transparent text-success border-0"
                      *ngIf="_authenticationService.hasCapability('create_candidate')"
                      (click)="transformToCandidate(row)"
                      [ngbTooltip]="'TRANSFORM_TO_CANDIDATE' | translate"
                    >
                      <i [data-feather]="'user-plus'" size="19"></i>
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'FIRSTNAME' | translate" prop="firstname" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.firstname + " " + row.lastname | titlecase }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'FIGURE' | translate" prop="figure_name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.figure_name ? row.figure_name : "-" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CITY' | translate" prop="city_name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.city_name ? row.city_name : "-" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'INSERT_DATE' | translate" prop="created_date" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ _utilService.formatDate(row.created_date, "DD/MM/YYYY HH:mm") }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'EMAIL' | translate" prop="email" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <a *ngIf="row.email" [href]="'mailto:' + row.email" class="text-danger" [ngbTooltip]="'SEND_EMAIL' | translate">
                  <i [data-feather]="'mail'" size="25" class="mr-1"></i>
                </a>
                <span>{{ row.email ? row.email : "-" }}</span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <button class="bg-transparent border-0 pr-1" (click)="modalOpen(detailCandidate, row)">
                  <i [data-feather]="'eye'" size="19"></i>
                </button>
                <button
                  class="bg-transparent text-success border-0 pr-1"
                  *ngIf="_authenticationService.hasCapability('create_candidate')"
                  (click)="transformToCandidate(row)"
                  [ngbTooltip]="'TRANSFORM_TO_CANDIDATE' | translate"
                >
                  <i [data-feather]="'user-plus'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
  </div>
</div>

<!-- Modal Detail Candidate -->
<ng-template #detailCandidate let-modal>
  <div class="modal-header">
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <div class="row">
      <div class="col-12 text-center">
        <div id="fake-avatar" class="rounded">
          <span>{{ selectedCandidate.firstname | initials | uppercase }}{{ selectedCandidate.lastname | initials | uppercase }}</span>
        </div>
        <h1 class="mt-1 text-capitalize">{{ selectedCandidate.firstname }} {{ selectedCandidate.lastname }}</h1>
        <div class="d-flex align-items-center justify-content-center mb-2 mt-1">
          <a class="mr-2 d-flex align-items-center text-primary" *ngIf="selectedCandidate.phone" [href]="'tel:' + selectedCandidate.phone" [ngbTooltip]="'CALL' | translate">
            <i [data-feather]="'phone'" size="25" class="text-primary mr-05"></i>
            <span>{{ selectedCandidate?.phone ? selectedCandidate.phone : "-" }}</span>
          </a>
          <a class="d-flex align-items-center text-primary" *ngIf="selectedCandidate.email" [href]="'mailto:' + selectedCandidate.email" [ngbTooltip]="'SEND_EMAIL' | translate">
            <i [data-feather]="'mail'" size="25" class="mr-05"></i>
            <span>{{ selectedCandidate?.email ? selectedCandidate.email : "-" }}</span>
          </a>
        </div>
        <div class="mb-1">
          {{ 'PROFESSIONAL_FIGURE' | translate }}:&nbsp;<strong>{{ selectedCandidate?.figure_name ? selectedCandidate.figure_name : "-" }}</strong>
        </div>
        <div class="mb-1">
          {{ 'CITY' | translate }}:&nbsp;<strong>{{ selectedCandidate?.city_name ? selectedCandidate.city_name : "-" }}</strong>
        </div>
        <div class="mb-1">
          {{ 'JOB_SITE' | translate }}:&nbsp;<strong>{{ selectedCandidate?.site_name ? selectedCandidate.site_name : "-" }}</strong>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center pb-0">
      <button class="btn btn-outline-primary" (click)="_utilService.getFile(selectedCandidate.cv_url)">{{ "VIEW_CV" | translate }}</button>
      <button type="submit" class="btn btn-primary ml-2" has_capability="create_candidate" (click)="transformToCandidate(selectedCandidate)">
        {{ "TRANSFORM_TO_CANDIDATE" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- / Modal Detail Candidate -->
